import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_NAV_USER } from '../gql/query';
import CatsPage from '../pages/cats';
import UnreadMessagesIndicator from './UnreadMessagesIndicator';


const Navigation = () => {
const [isAct, setAct] = useState(false);
const [isMenuOpen, setIsMenuOpen] = useState(false);
const rootEl = useRef(null);
const mobileMenuRef = useRef(null);
const isLoggedIn = !!localStorage.getItem('token');

  // close popup when clicking outside
  useEffect(() => {
    const onClick = e => {
      if (isMenuOpen && rootEl.current && !rootEl.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [isMenuOpen]);

  useEffect(() => {
    const onClickOutside = event => {
      if (isAct && mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) setAct(false);
    };
    const onKeyDown = event => {
      if (event.key === 'Escape') {
        setAct(false);
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('click', onClickOutside);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('click', onClickOutside);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [isAct]);


const handleToggle = () => {
    setAct(open => !open);
  };
const closeMobileMenu = () => setAct(false);
const logout = () => {
  localStorage.removeItem('token');
  window.location.replace('/');
};

const { data, loading, error } = useQuery(GET_NAV_USER, { skip: !isLoggedIn });
if (isLoggedIn && loading) return <p>Загрузка...</p>;
if (isLoggedIn && error) {
  console.error('Error fetching user data:', error);
  return <p>Ошибка при загрузке данных пользователя.</p>;
}

console.log('Navigation data:', data);
return (
    <div id="ahead">
    <div className="top_head">
      <nav>
        <ul>
          <li className="logotype">
          <NavLink to="/" onClick={() => {
            isAct && handleToggle()
          }} >
            <svg width="44" height="44" viewBox="0 0 65 59">
            <path className="als-1" d="M30,56.966a27.72,27.72,0,1,1,27.712-27.72A27.716,27.716,0,0,1,30,56.966ZM30,8.392A20.853,20.853,0,1,0,50.848,29.246,20.85,20.85,0,0,0,30,8.392Z"/>
            <path className="als-2" d="M48.348,30.068H48.106l0.134,0.385h-36.4l0.134-.385H11.652c-0.012-.273-0.021-0.546-0.021-0.822a18.369,18.369,0,1,1,36.737,0C48.369,29.522,48.36,29.8,48.348,30.068ZM30,16.747a12.5,12.5,0,0,0-11.646,7.97H41.646A12.5,12.5,0,0,0,30,16.747Zm0,25A12.5,12.5,0,0,0,42.036,32.6h6.022a18.365,18.365,0,0,1-36.115,0h6.022A12.5,12.5,0,0,0,30,41.744Z"/>
            </svg>
            <span>ichor.by
						<p>интересные мировые новости</p>
						</span>
          </NavLink>
          </li>
          {/* <li>
            <NavLink  to="/about" style={({ isActive }) => ({

                })}>О себе</NavLink>
          </li> */}
          <li className="hvsubmenu">
            <span>
              <ul>
                  <CatsPage />
              </ul>
              </span>
          </li>
           {isLoggedIn ? (
           <>
                    <li className="log-out" ref={rootEl}  onClick={() => { setIsMenuOpen(!isMenuOpen); }} style={{ background: isMenuOpen ? '#159dc3' : 'transparent', border: isMenuOpen ? 'none' : '' }} >
                           <div className="user-info">
                            <img className="avatar" src={data?.me?.avatar || ''} alt={data?.me?.name || 'User'} />
                            <div className='me-name'>{data?.me?.name}</div>
                            <div style={{ marginLeft: 6 }}><UnreadMessagesIndicator /></div>
                            </div>
                            <div className={`popup-menu ${isMenuOpen ? 'open' : 'closed'}`}>
                                <ul className="popup-list">
                                  <li>
                                    <NavLink to="/myprofile" onClick={() => setIsMenuOpen(false)} className="popup-link">
                                      Профиль
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink to="/chat" onClick={() => setIsMenuOpen(false)} className="popup-link">
                                      Чаты
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink to="/settings" onClick={() => setIsMenuOpen(false)} className="popup-link">
                                      Настройки приватности
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink to="/new" onClick={() => setIsMenuOpen(false)} className="popup-link">
                                      Создать&nbsp;+
                                    </NavLink>
                                  </li>
                                  {data?.me?.isAdmin && (
                                    <li>
                                      <NavLink to="/admin" onClick={() => setIsMenuOpen(false)} className="popup-link">
                                        Админка
                                      </NavLink>
                                    </li>
                                  )}
                                  <li>
                                    <Link to="#" onClick={() => { logout(); setIsMenuOpen(false); }} className="popup-link">
                                      Выйти
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                        </li>
                        
                        </>
          ) : (
            <>
          <li>
              <Link to="/signup">Создать аккаунт</Link>
          </li>
          <li>
              <Link to="/signin">Авторизация</Link>
          </li>
          </>
            )}
        </ul>
      </nav>
    </div>
                <div className="nav-wrap" ref={mobileMenuRef}>
                <button type="button" className="menu-icon" onClick={handleToggle} aria-expanded={isAct} aria-controls="mobile-main-menu" aria-label={isAct ? 'Закрыть меню' : 'Открыть главное меню'}>
                        <svg id="menu_mobile" width="36" height="36" viewBox="0 0 36 36" aria-hidden="true">
                          <path className="cls-1 menu-icon__line menu-icon__line--top" d="M15,16.6V15h9v1.6H15Z" transform="translate(-1 -1)"/>
                          <path className="cls-2 menu-icon__line menu-icon__line--middle" d="M15,19.8V18.2h9v1.6H15Z" transform="translate(-1 -1)"/>
                          <path className="cls-3 menu-icon__line menu-icon__line--bottom" d="M15,23V21.4h9V23H15Z" transform="translate(-1 -1)"/>
        								<path className="cls-4" d="M19,1A18,18,0,1,1,1,19,18,18,0,0,1,19,1Zm0,4A14,14,0,1,1,5,19,14,14,0,0,1,19,5Z" transform="translate(-1 -1)"/>
        						</svg>
        				    <span>Разделы</span>
                </button>
                <nav className={`mobile-main-menu ${isAct ? 'is-open' : ''}`} id="mobile-main-menu" aria-label="Главное меню" aria-hidden={!isAct}>
                  <NavLink to="/" className="mobile-main-menu__item" onClick={closeMobileMenu}>Главная</NavLink>
                  <NavLink to="/about" className="mobile-main-menu__item" onClick={closeMobileMenu}>О проекте</NavLink>
                  <details className="mobile-main-menu__categories">
                    <summary>Разделы</summary>
                    <div className="mobile-main-menu__category-links" onClick={closeMobileMenu}>
                      <CatsPage />
                    </div>
                  </details>
                  {isLoggedIn ? (
                    <>
                      <NavLink to="/myprofile" className="mobile-main-menu__item" onClick={closeMobileMenu}>Профиль</NavLink>
                      <NavLink to="/chat" className="mobile-main-menu__item" onClick={closeMobileMenu}>Чаты</NavLink>
                      <NavLink to="/settings" className="mobile-main-menu__item" onClick={closeMobileMenu}>Настройки приватности</NavLink>
                      <NavLink to="/new" className="mobile-main-menu__item" onClick={closeMobileMenu}>Создать запись <span>＋</span></NavLink>
                      {data?.me?.isAdmin && <NavLink to="/admin" className="mobile-main-menu__item" onClick={closeMobileMenu}>Админка</NavLink>}
                      <button type="button" className="mobile-main-menu__item mobile-main-menu__logout" onClick={logout}>Выйти ({data.me.name})</button>
                    </>
                  ) : (
                    <>
                      <NavLink to="/signup" className="mobile-main-menu__item" onClick={closeMobileMenu}>Создать аккаунт</NavLink>
                      <NavLink to="/signin" className="mobile-main-menu__item" onClick={closeMobileMenu}>Авторизация</NavLink>
                    </>
                  )}
                </nav>
</div>
    </div>
  );
};

export default Navigation;
